module.exports = __webpack_public_path__ + "media/images/icons/current_location-609115a8f21cbc7441e99c3029dc89e1.svg";